import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy } from 'lodash';
import Modal from '@bd/bdui-modal';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { Image, SanitizeHtml } from '@bd/bdcore-utilities';
import { colors, typography } from '../styles';
import Form from './Forms/Form';

const styles = css`
  .ContactButton:focus {
    outline: 0;
  }
`;

const modalStyles = css`
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
  width: auto;
  margin: 0;
  height: auto;
  background-color:${colors.white};
  @media (min-width: 992px) {
    top: 30px;
    left: 50%;
    right: auto;
    width: 580px;
    margin-left: -290px;
  }
  .ContactModal_close {
    display: block;
    position: absolute;
    right: 15px;
    top: 15px;
    width: 15px;
    height: 15px;
    padding: 0;
    box-sizing: content-box;
    background-image: url('/images/icon-close-white.svg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 15px 15px;
    background-color: transparent;
    border: 0;
    cursor: pointer;
    z-index: 2;
  }
  .ContactModal_header {
    background-image: url('/images/bg-contact-modal-header.svg');
    background-size: cover;
    z-index: 1;
    position: relative;
    padding: 10px 60px 10px 15px;
    @media (min-width: 992px) {
      padding: 30px 30px 30px 30px;
    }
  }
  .ContactModal_oscImage {
    display: none;
    @media (min-width: 992px) {
      display: block;
      width: 150px;
      height: 150px;
      border-radius: 50%;
      background-color: ${colors.brand4};
    }
  }
  .ContactModal_title {
    font-family: ${typography.Serif};
    font-size: 21px;
    line-height: 1.1;
    font-weight: 700;
    margin: 0 0 15px 0;
    color: ${colors.white};
    @media (min-width: 992px) {
      font-size: 32px;
    }
  }
  .ContactModal_text p {
    display: block;
    font-size: 18px;
    line-height: 1.2;
    margin: 0;
    font-weight: 400;
    text-transform: none;
    color: ${colors.brand5};
    @media (min-width: 992px) {
      font-size: 21px;
    }
  }

  .ContactModal_body {
    padding: 15px 0;
    position: relative;
    z-index: 2;
    @media (min-width: 992px) {
      padding: 30px 15px;
    }
  }
  .ContactModal_footer {
    background-color: ${colors.neutral};
    padding: 20px 15px;
    position: relative;
    z-index: 2;
    font-size: 13px;
    @media (min-width: 992px) {
      display: none;
    }
    a {
      background-color: ${colors.brand1};
      color: ${colors.white};
      padding: 8px 15px;
      font-weight: 800;
      font-size: 13px;
      line-height: 15px;
      display: block;
      text-align: center;
      img {
        margin: 0 10px 0 0;
        max-height:20px;
      }
    }
  }

  .invalid-feedback {
    color: red;
  }
`;

const modalOverlayStyles = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background-color: rgba(0,0,0, 0.75);
  overflow-y: auto;
`;

class ContactModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(e) {
    let currentElem = e.target;

    while (currentElem.tagName !== 'A' && currentElem.parentNode !== document) {
      currentElem = currentElem.parentNode;
    }

    if (currentElem.nodeName !== 'A') {
      e.preventDefault();
      this.setState({
        modalIsOpen: true,
      });
    }
  }

  closeModal(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ modalIsOpen: false });
  }

  render() {
    const { children, agent, widget, communities } = this.props;
    const communitiesList = orderBy(communities, 'name', 'asc').map(community => ({ label: `${get(community, 'name')} - ${get(community, 'address.addressLocality')}`, value: get(community, '_id') }));
    return (
      <div className={styles}>
        <span className="ContactButton" role="button" tabIndex={0} onClick={this.openModal}>
          {children}
        </span>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Contact Modal"
          className={modalStyles}
          overlayClassName={modalOverlayStyles}
        >
          <button className="ContactModal_close" onClick={this.closeModal} />
          <div className="ContactModal_header">
            <div className="row">
              {
                get(agent, 'logo.contentUrl') &&
                <div className="col-md-4">
                  <Image
                    src={get(agent, 'logo.contentUrl')}
                    className="ContactModal_oscImage"
                    width={300}
                    height={300}
                    exact
                    alt={get(agent, 'logo.name', get(agent, 'logo.caption', ''))}
                  />
                </div>
              }
              <div className="col-md-7">
                <h2 className="ContactModal_title">
                  {get(widget, 'get_updates_form[0].get_updates_form_headline')}
                </h2>
                <div className="ContactModal_text" dangerouslySetInnerHTML={SanitizeHtml(get(widget, 'get_updates_form[0].get_updates_form_text'))} />
              </div>
            </div>
          </div>
          <div className="ContactModal_body">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Form
                    formName="getUpdatesModal"
                    formLabel="Get Updates Modal"
                    fields={[
                      {
                        type: 'Text',
                        label: 'First Name',
                        className: 'form-col',
                        field: 'firstName',
                        required: true,
                      },
                      {
                        type: 'Text',
                        label: 'Last Name',
                        className: 'form-col',
                        field: 'lastName',
                        required: true,
                      },
                      {
                        type: 'Email',
                        label: 'Email',
                        className: 'form-col',
                        field: 'email',
                        required: true,
                        requiredMessage: '',
                        invalidMessage: '',
                      },
                      {
                        type: 'Phone',
                        label: 'Phone',
                        className: 'form-col',
                        field: 'phone',
                        required: false,
                        requiredMessage: '',
                        invalidMessage: '',
                      },
                      {
                        type: 'Select',
                        label: 'Community Of Interest',
                        field: 'com',
                        className: 'form-col',
                        required: true,
                        options: communitiesList,
                      },
                      {
                        type: 'TextArea',
                        label: 'Comments/Questions',
                        className: 'form-col-fluid',
                        placeholder: 'How can we help you?',
                        field: 'comments',
                        required: false,
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

ContactModal.propTypes = {
  agent: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  widget: PropTypes.object.isRequired,
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData(
  {
    community: true,
    agent: true,
    widget: 'contact_banner',
    communities: 'all',
  },
  {
    required: {
      agent: true,
      communities: true,
    },
  },
)(ContactModal);



// WEBPACK FOOTER //
// ./src/components/GetUpdatesModal.js